import type { QuickStartSectionRef } from '../github.interface'

import { resolveLanguageList } from './utils/resolveLanguageList'
import { stripNumericPathPrefix } from './utils/stripNumericPathPrefix'

export function resolveQuickStartSlug(
  slug: string[],
  sections: QuickStartSectionRef[]
): { articlePath: string; language: string } | null {
  if (slug.length === 0) return null

  const joined = slug.join('/')

  const singleLangMatch = sections.find((s) => {
    const langs = resolveLanguageList(s)
    return langs.length === 1 && stripNumericPathPrefix(s.path) === joined
  })
  if (singleLangMatch) {
    const langs = resolveLanguageList(singleLangMatch)
    return { articlePath: singleLangMatch.path, language: singleLangMatch.defaultLanguage ?? langs[0]! }
  }

  if (slug.length >= 2) {
    const lang = slug[slug.length - 1]!.toLowerCase()
    const urlArticlePath = slug.slice(0, -1).join('/')
    const multi = sections.find(
      (s) => stripNumericPathPrefix(s.path) === urlArticlePath && (s.languages ?? []).includes(lang)
    )
    if (multi) return { articlePath: multi.path, language: lang }
  }

  return null
}
